import { render, staticRenderFns } from "./AdminForm.vue?vue&type=template&id=c9dfa7ea&"
import script from "./AdminForm.vue?vue&type=script&lang=js&"
export * from "./AdminForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminForm.vue?vue&type=style&index=0&id=c9dfa7ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports